export default __webpack_public_path__ + "static/media/Antenado.48e5ff80.svg";